export default __webpack_public_path__ + "Box.8551c48c4a4d7cba87016445d74c87a2.svg";